// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.perxis-auto-1_18_1-car-card {
  /* Colors */
  --perxis-auto-car-card-background-color-inner: var(
    --perxis-auto-car-card-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  background-color: var(--perxis-auto-car-card-background-color-inner);
}

.perxis-auto-1_18_1-car-card-image .perxis-auto-1_18_1-car-card-image__skeleton {
  height: 100%;
}
.perxis-auto-1_18_1-car-card-image .perxis-auto-1_18_1-car-card-image__skeleton .ant-5_24_1-skeleton.ant-5_24_1-skeleton-element {
  width: 100%;
  height: 100%;
}
.perxis-auto-1_18_1-car-card-image .perxis-auto-1_18_1-car-card-image__skeleton .ant-5_24_1-skeleton.ant-5_24_1-skeleton-element .ant-5_24_1-skeleton-image {
  width: 100%;
  height: 100%;
  padding-bottom: 60%;
  position: relative;
}
.perxis-auto-1_18_1-car-card-image .perxis-auto-1_18_1-car-card-image__skeleton .ant-5_24_1-skeleton.ant-5_24_1-skeleton-element .ant-5_24_1-skeleton-image .ant-5_24_1-skeleton-image-svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.perxis-auto-1_18_1-car-card-location {
  /* Typography */
  --perxis-auto-car-card-location-text-font-family-inner: var(
    --perxis-auto-car-card-location-text-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-car-card-location-text-font-size-inner: var(
    --perxis-auto-car-card-location-text-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-location-text-font-weight-inner: var(
    --perxis-auto-car-card-location-text-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-car-card-location-text-letter-spacing-inner: var(
    --perxis-auto-car-card-location-text-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-car-card-location-text-line-height-inner: var(
    --perxis-auto-car-card-location-text-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-car-card-location-text-text-transform-inner: var(
    --perxis-auto-car-card-location-text-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-car-card-location-text-color-inner: var(
    --perxis-auto-car-card-location-text-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-car-card-location-icon-color-inner: var(
    --perxis-auto-car-card-location-icon-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-car-card-location-icon-font-size-inner: var(
    --perxis-auto-car-card-location-icon-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  /* End Typography */
}
.perxis-auto-1_18_1-car-card-location__text {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-car-card-location-text-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-car-card-location-text-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-car-card-location-text-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-car-card-location-text-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-car-card-location-text-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-car-card-location-text-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-car-card-location-text-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-car-card-location-text-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-car-card-location-text-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-car-card-location-text-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-car-card-location-text-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-car-card-location-text-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-car-card-location-text-line-height-inner);
}
.perxis-auto-1_18_1-car-card-location__icon {
  --perxis-auto-typography-color-light: var(--perxis-auto-car-card-location-icon-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-car-card-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-car-card-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-car-card-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-car-card-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-car-card-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-car-card-location-icon-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-car-card-location-icon-font-size-inner);
}
.perxis-auto-1_18_1-car-card-location,
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-typography.perxis-auto-1_18_1-text {
  display: inline-flex;
  align-items: center;
}
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-typography.perxis-auto-1_18_1-car-card-location__icon .perxis-auto-1_18_1-icon {
  margin-right: 8px;
}
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-car-card-location__skeleton.ant-5_24_1-skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-car-card-location__skeleton.ant-5_24_1-skeleton.ant-5_24_1-skeleton-with-avatar {
  display: flex;
  align-items: center;
}
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-car-card-location__skeleton.ant-5_24_1-skeleton.ant-5_24_1-skeleton-with-avatar .ant-5_24_1-skeleton-header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-car-card-location__skeleton.ant-5_24_1-skeleton.ant-5_24_1-skeleton-with-avatar .ant-5_24_1-skeleton-header .ant-5_24_1-skeleton-avatar {
  height: 18px;
  width: 18px;
}
.perxis-auto-1_18_1-car-card-location .perxis-auto-1_18_1-car-card-location__skeleton .ant-5_24_1-skeleton-paragraph {
  width: 120px;
}

.perxis-auto-1_18_1-car-card-table {
  /* Typography */
  --perxis-auto-car-card-table-name-font-family-inner: var(
    --perxis-auto-car-card-table-name-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-car-card-table-name-font-size-inner: var(
    --perxis-auto-car-card-table-name-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-car-card-table-name-line-height-inner: var(
    --perxis-auto-car-card-table-name-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-car-card-table-name-font-weight-inner: var(
    --perxis-auto-car-card-table-name-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-car-card-table-name-color-inner: var(
    --perxis-auto-car-card-table-name-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-car-card-table-value-font-family-inner: var(
    --perxis-auto-car-card-table-value-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-car-card-table-value-font-size-inner: var(
    --perxis-auto-car-card-table-value-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-car-card-table-value-line-height-inner: var(
    --perxis-auto-car-card-table-value-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-car-card-table-value-font-weight-inner: var(--perxis-auto-car-card-table-value-font-weight, 700);
  --perxis-auto-car-card-table-value-color-inner: var(
    --perxis-auto-car-card-table-value-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* Border */
  --perxis-auto-car-card-table-border-width-inner: var(--perxis-auto-car-card-table-border-width, 1px);
  --perxis-auto-car-card-table-border-color-inner: var(
    --perxis-auto-car-card-table-border-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-table-border-top-width: 0;
  --perxis-auto-table-border-bottom-width: var(--perxis-auto-car-card-table-border-width-inner);
  --perxis-auto-table-border-color-inner: var(--perxis-auto-car-card-table-border-color-inner);
  /* End Border */
}
.perxis-auto-1_18_1-car-card-table__item {
  display: flex;
  align-items: center;
}
.perxis-auto-1_18_1-car-card-table__item .perxis-auto-1_18_1-typography.perxis-auto-1_18_1-text {
  display: inline-flex;
  align-items: center;
}
.perxis-auto-1_18_1-car-card-table__item-name {
  --perxis-auto-typography-color-dark: var(--perxis-auto-car-card-table-name-color-inner);
  --perxis-auto-typography-main-font-family: var(--perxis-auto-car-card-table-name-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-car-card-table-name-font-weight-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-car-card-table-name-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-car-card-table-name-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-car-card-table-name-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-car-card-table-name-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-car-card-table-name-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-car-card-table-name-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-car-card-table-name-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-car-card-table-name-line-height-inner);
}
.perxis-auto-1_18_1-car-card-table__item-value {
  --perxis-auto-typography-color-darkest: var(--perxis-auto-car-card-table-value-color-inner);
  --perxis-auto-typography-main-font-family: var(--perxis-auto-car-card-table-value-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-car-card-table-value-font-weight-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-car-card-table-value-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-car-card-table-value-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-car-card-table-value-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-car-card-table-value-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-car-card-table-value-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-car-card-table-value-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-car-card-table-value-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-car-card-table-value-line-height-inner);
}
.perxis-auto-1_18_1-car-card-table .perxis-auto-1_18_1-car-card-table__skeleton .ant-5_24_1-skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_18_1-car-card-table .perxis-auto-1_18_1-car-card-table__skeleton .ant-5_24_1-skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 24px;
}

.perxis-auto-1_18_1-car-card-price {
  /* Typography */
  --perxis-auto-car-card-price-title-font-size-inner: var(
    --perxis-auto-car-card-price-title-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-price-font-size-inner: var(
    --perxis-auto-car-card-price-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-price-discount-font-size-inner: var(
    --perxis-auto-car-card-price-discount-font-size,
    var(--perxis-auto-root-typography-h2-font-size-xxl-inner)
  );
  /* End Typography */
  /* Typography icon */
  --perxis-auto-car-card-price-icon-color-inner: var(
    --perxis-auto-car-card-price-icon-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-car-card-price-icon-size-inner: var(
    --perxis-auto-car-card-price-icon-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  /* End Typography icon*/
}
.perxis-auto-1_18_1-car-card-price.perxis-auto-1_18_1-price {
  --perxis-auto-price-title-font-size: var(--perxis-auto-car-card-price-title-font-size-inner);
  --perxis-auto-price-current-font-size: var(--perxis-auto-car-card-price-discount-font-size);
  --perxis-auto-price-old-font-size: var(--perxis-auto-car-card-price-font-size-inner);
}
.perxis-auto-1_18_1-car-card-price.perxis-auto-1_18_1-price .perxis-auto-1_18_1-price-current {
  margin-bottom: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-car-card-price.perxis-auto-1_18_1-price .perxis-auto-1_18_1-car-card-price__benefits-icon.perxis-auto-1_18_1-typography {
  --perxis-auto-typography-color-darkest-inner: var(--perxis-auto-car-card-price-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-car-card-price-icon-size-inner);
  display: flex;
}
.perxis-auto-1_18_1-car-card-price .perxis-auto-1_18_1-car-card-price__skeleton .ant-5_24_1-skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_18_1-car-card-price .perxis-auto-1_18_1-car-card-price__skeleton-value.ant-5_24_1-skeleton-input {
  width: 110px;
  height: 20px;
}
@media (min-width: 1600px) {
  .perxis-auto-1_18_1-car-card-price .perxis-auto-1_18_1-car-card-price__skeleton-value.ant-5_24_1-skeleton-input {
    width: 170px;
    height: 32px;
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_18_1-car-card-price .perxis-auto-1_18_1-car-card-price__skeleton-value.ant-5_24_1-skeleton-input {
    width: 150px;
    height: 28px;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  .perxis-auto-1_18_1-car-card-price .perxis-auto-1_18_1-car-card-price__skeleton-value.ant-5_24_1-skeleton-input {
    width: 130px;
    height: 24px;
  }
}

.perxis-auto-1_18_1-car-card-price__benefits {
  --perxis-auto-car-card-price-tooltip-max-width-inner: var(--perxis-auto-car-card-price-tooltip-max-width, 385px);
  --perxis-auto-car-card-price-tooltip-padding-block-inner: var(
    --perxis-auto-car-card-price-tooltip-padding-block,
    var(--perxis-auto-gap-vertical-sky-inner)
  );
  --perxis-auto-car-card-price-tooltip-padding-inline-inner: var(
    --perxis-auto-car-card-price-tooltip-padding-inline,
    18px
  );
}
.perxis-auto-1_18_1-car-card-price__benefits.perxis-auto-1_18_1-tooltip.ant-5_24_1-tooltip {
  width: 100%;
  --perxis-auto-tooltip-max-width: var(--perxis-auto-car-card-price-tooltip-max-width-inner);
  --perxis-auto-tooltip-content-padding-block: var(--perxis-auto-car-card-price-tooltip-padding-block-inner);
  --perxis-auto-tooltip-content-padding-inline: var(--perxis-auto-car-card-price-tooltip-padding-inline-inner);
}
@media (max-width: 576px) {
  .perxis-auto-1_18_1-car-card-price__benefits.perxis-auto-1_18_1-tooltip.ant-5_24_1-tooltip {
    --perxis-auto-tooltip-max-width: none;
    padding: 0 2%;
  }
}

.perxis-auto-1_18_1-car-card-payment {
  /* Typography */
  --perxis-auto-car-card-payment-title-font-size-inner: var(
    --perxis-auto-car-card-payment-title-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-payment-font-size-inner: var(
    --perxis-auto-car-card-payment-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-payment-discount-font-size-inner: var(
    --perxis-auto-car-card-payment-discount-font-size,
    var(--perxis-auto-root-typography-h2-font-size-xxl-inner)
  );
  --perxis-auto-car-card-payment-title-color-inner: var(
    --perxis-auto-car-card-payment-title-color,
    var(--perxis-auto-root-fifth-color-inner)
  );
  --perxis-auto-car-card-payment-value-color-inner: var(
    --perxis-auto-car-card-payment-value-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  /* End Typography */
}
.perxis-auto-1_18_1-car-card-payment.perxis-auto-1_18_1-price {
  --perxis-auto-price-title-font-size: var(--perxis-auto-car-card-payment-title-font-size-inner);
  --perxis-auto-price-current-font-size: var(--perxis-auto-car-card-payment-discount-font-size);
  --perxis-auto-price-old-font-size: var(--perxis-auto-car-card-payment-font-size-inner);
}
.perxis-auto-1_18_1-car-card-payment.perxis-auto-1_18_1-price .perxis-auto-1_18_1-typography {
  --perxis-auto-typography-color-dark-light-inner: var(--perxis-auto-car-card-payment-value-color-inner);
  --perxis-auto-typography-color-dark-inner: var(--perxis-auto-car-card-payment-title-color-inner);
}
.perxis-auto-1_18_1-car-card-payment.perxis-auto-1_18_1-price .perxis-auto-1_18_1-price-current {
  margin-bottom: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-car-card-payment .perxis-auto-1_18_1-car-card-payment__skeleton .ant-5_24_1-skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_18_1-car-card-payment .perxis-auto-1_18_1-car-card-payment__skeleton-value.ant-5_24_1-skeleton-input {
  width: 110px;
  height: 20px;
}
@media (min-width: 1600px) {
  .perxis-auto-1_18_1-car-card-payment .perxis-auto-1_18_1-car-card-payment__skeleton-value.ant-5_24_1-skeleton-input {
    width: 170px;
    height: 32px;
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_18_1-car-card-payment .perxis-auto-1_18_1-car-card-payment__skeleton-value.ant-5_24_1-skeleton-input {
    width: 150px;
    height: 28px;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  .perxis-auto-1_18_1-car-card-payment .perxis-auto-1_18_1-car-card-payment__skeleton-value.ant-5_24_1-skeleton-input {
    width: 130px;
    height: 24px;
  }
}

.perxis-auto-1_18_1-car-card-title {
  /* Typography */
  --perxis-auto-car-card-title-heading-font-family-inner: var(
    --perxis-auto-car-card-title-heading-font-family,
    var(--perxis-auto-root-typography-h1-font-family-inner)
  );
  --perxis-auto-car-card-title-heading-font-size-xxs-md-inner: var(
    --perxis-auto-car-card-title-heading-font-size-xxs-md,
    28px
  );
  --perxis-auto-car-card-title-heading-font-size-lg-inner: var(--perxis-auto-car-card-title-heading-font-size-lg, 32px);
  --perxis-auto-car-card-title-heading-font-size-xl-xxl-inner: var(
    --perxis-auto-car-card-title-heading-font-size-xl-xxl,
    36px
  );
  --perxis-auto-car-card-title-heading-font-weight-inner: var(
    --perxis-auto-car-card-title-heading-font-weight,
    var(--perxis-auto-root-typography-h1-font-weight-inner)
  );
  --perxis-auto-car-card-title-heading-letter-spacing-inner: var(
    --perxis-auto-car-card-title-heading-letter-spacing,
    var(--perxis-auto-root-typography-h1-letter-spacing-inner)
  );
  --perxis-auto-car-card-title-heading-line-height-inner: var(
    --perxis-auto-car-card-title-heading-line-height,
    var(--perxis-auto-root-typography-h1-line-height-inner)
  );
  --perxis-auto-car-card-title-heading-text-transform-inner: var(
    --perxis-auto-car-card-title-heading-text-transform,
    var(--perxis-auto-root-typography-h1-text-transform-inner)
  );
  --perxis-auto-car-card-title-heading-color-inner: var(
    --perxis-auto-car-card-title-heading-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-car-card-title-description-font-family-inner: var(
    --perxis-auto-car-card-title-description-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-car-card-title-description-font-size-inner: var(
    --perxis-auto-car-card-title-description-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-car-card-title-description-font-weight-inner: var(
    --perxis-auto-car-card-title-description-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-car-card-title-description-letter-spacing-inner: var(
    --perxis-auto-car-card-title-description-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-car-card-title-description-line-height-inner: var(
    --perxis-auto-car-card-title-description-line-height,
    var(--perxis-auto-root-typography-main-line-height-inner)
  );
  --perxis-auto-car-card-title-description-text-transform-inner: var(
    --perxis-auto-car-card-title-description-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-car-card-title-description-color-inner: var(
    --perxis-auto-car-card-title-description-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Typography */
}
.perxis-auto-1_18_1-car-card-title__heading {
  --perxis-auto-typography-h1-font-family: var(--perxis-auto-car-card-title-heading-font-family-inner);
  --perxis-auto-typography-h1-font-weight: var(--perxis-auto-car-card-title-heading-font-weight-inner);
  --perxis-auto-typography-h1-letter-spacing: var(--perxis-auto-car-card-title-heading-letter-spacing-inner);
  --perxis-auto-typography-h1-text-transform: var(--perxis-auto-car-card-title-heading-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-car-card-title-heading-color-inner);
  --perxis-auto-typography-h1-line-height-xxs: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-line-height-xs: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-line-height-sm: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-line-height-md: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-line-height-lg: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-line-height-xl: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-line-height-xxl: var(--perxis-auto-car-card-title-heading-line-height-inner);
  --perxis-auto-typography-h1-font-size-xxs: var(--perxis-auto-car-card-title-heading-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-xs: var(--perxis-auto-car-card-title-heading-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-sm: var(--perxis-auto-car-card-title-heading-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-md: var(--perxis-auto-car-card-title-heading-font-size-xxs-md-inner);
  --perxis-auto-typography-h1-font-size-lg: var(--perxis-auto-car-card-title-heading-font-size-lg-inner);
  --perxis-auto-typography-h1-font-size-xl: var(--perxis-auto-car-card-title-heading-font-size-xl-xxl-inner);
  --perxis-auto-typography-h1-font-size-xxl: var(--perxis-auto-car-card-title-heading-font-size-xl-xxl-inner);
}
.perxis-auto-1_18_1-car-card-title__description {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-car-card-title-description-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-car-card-title-description-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-car-card-title-description-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-car-card-title-description-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-car-card-title-description-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-car-card-title-description-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-car-card-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-car-card-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-car-card-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-car-card-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-car-card-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-car-card-title-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-car-card-title-description-line-height-inner);
}
.perxis-auto-1_18_1-car-card-title .perxis-auto-1_18_1-car-card-title__skeleton-title.ant-5_24_1-skeleton-input {
  width: 100%;
  height: 24px;
}
.perxis-auto-1_18_1-car-card-title .perxis-auto-1_18_1-car-card-title__skeleton-description.ant-5_24_1-skeleton-input {
  width: 50%;
  height: 20px;
}

.perxis-auto-1_18_1-car-card-markers {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.perxis-auto-1_18_1-car-card-markers__skeleton.ant-5_24_1-skeleton .ant-5_24_1-skeleton-input {
  min-width: 80px;
  height: 20px;
}

.perxis-auto-1_18_1-car-card-markers__marker-tooltip {
  /* Typography */
  --perxis-auto-car-card-markers-marker-tooltip-font-size-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-markers-marker-tooltip-font-family-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-car-card-markers-marker-tooltip-font-weight-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-car-card-markers-marker-tooltip-letter-spacing-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-car-card-markers-marker-tooltip-line-height-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-car-card-markers-marker-tooltip-text-transform-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-car-card-markers-marker-tooltip-color-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-car-card-markers-marker-tooltip-background-color-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Padding */
  --perxis-auto-car-card-markers-marker-tooltip-padding-block-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-padding-block,
    6px
  );
  --perxis-auto-car-card-markers-marker-tooltip-padding-inline-inner: var(
    --perxis-auto-car-card-markers-marker-tooltip-padding-inline,
    12px
  );
  /* End Padding */
  --perxis-auto-markers-marker-tooltip-font-size: var(--perxis-auto-car-card-markers-marker-tooltip-font-size-inner);
  --perxis-auto-markers-marker-tooltip-font-family: var(
    --perxis-auto-car-card-markers-marker-tooltip-font-family-inner
  );
  --perxis-auto-markers-marker-tooltip-font-weight: var(
    --perxis-auto-car-card-markers-marker-tooltip-font-weight-inner
  );
  --perxis-auto-markers-marker-tooltip-letter-spacing: var(
    --perxis-auto-car-card-markers-marker-tooltip-letter-spacing-inner
  );
  --perxis-auto-markers-marker-tooltip-line-height: var(
    --perxis-auto-car-card-markers-marker-tooltip-line-height-inner
  );
  --perxis-auto-markers-marker-tooltip-text-transform: var(
    --perxis-auto-car-card-markers-marker-tooltip-text-transform-inner
  );
  --perxis-auto-markers-marker-tooltip-color: var(--perxis-auto-car-card-markers-marker-tooltip-color-inner);
  --perxis-auto-markers-marker-tooltip-background-color: var(
    --perxis-auto-car-card-markers-marker-tooltip-background-color-inner
  );
  --perxis-auto-markers-marker-tooltip-padding-block: var(
    --perxis-auto-car-card-markers-marker-tooltip-padding-block-inner
  );
  --perxis-auto-markers-marker-tooltip-padding-inline: var(
    --perxis-auto-car-card-markers-marker-tooltip-padding-inline-inner
  );
}

.perxis-auto-1_18_1-car-card-markers__more-tooltip {
  /* Colors */
  --perxis-auto-car-card-markers-more-tooltip-color-inner: var(
    --perxis-auto-car-card-markers-more-tooltip-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-car-card-markers-more-tooltip-background-color-inner: var(
    --perxis-auto-car-card-markers-more-tooltip-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Padding */
  --perxis-auto-car-card-markers-more-tooltip-padding-block-inner: var(
    --perxis-auto-car-card-markers-more-tooltip-padding-block,
    var(--perxis-auto-gap-vertical-sky-inner)
  );
  --perxis-auto-car-card-markers-more-tooltip-padding-inline-inner: var(
    --perxis-auto-car-card-markers-more-tooltip-padding-inline,
    18px
  );
  /* End Padding */
  --perxis-auto-markers-more-tooltip-color: var(--perxis-auto-car-card-markers-more-tooltip-color-inner);
  --perxis-auto-markers-more-tooltip-background-color: var(
    --perxis-auto-car-card-markers-more-tooltip-background-color-inner
  );
  --perxis-auto-markers-more-tooltip-padding-block: var(
    --perxis-auto-car-card-markers-more-tooltip-padding-block-inner
  );
  --perxis-auto-markers-more-tooltip-padding-inline: var(
    --perxis-auto-car-card-markers-more-tooltip-padding-inline-inner
  );
}

.perxis-auto-1_18_1-car-card-markers__more-list {
  /* Typography */
  --perxis-auto-car-card-markers-more-list-font-family-inner: var(
    --perxis-auto-car-card-markers-more-list-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --perxis-auto-car-card-markers-more-list-font-size-inner: var(
    --perxis-auto-car-card-markers-more-list-font-size,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-car-card-markers-more-list-line-height-inner: var(
    --perxis-auto-car-card-markers-more-list-line-height,
    2
  );
  --perxis-auto-car-card-markers-more-list-font-weight-inner: var(
    --perxis-auto-car-card-markers-more-list-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --perxis-auto-car-card-markers-more-list-type-inner: var(--perxis-auto-car-card-markers-more-list-type, "—");
  /* End Typography */
  --perxis-auto-markers-more-list-font-family: var(--perxis-auto-car-card-markers-more-list-font-family-inner);
  --perxis-auto-markers-more-list-font-size: var(--perxis-auto-car-card-markers-more-list-font-size-inner);
  --perxis-auto-markers-more-list-line-height: var(--perxis-auto-car-card-markers-more-list-line-height-inner);
  --perxis-auto-markers-more-list-font-weight: var(--perxis-auto-car-card-markers-more-list-font-weight-inner);
  --perxis-auto-markers-more-list-type: var(--perxis-auto-car-card-markers-more-list-type-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
